import * as React from 'react';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {MinusIcon} from '../icon/svg/minus-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PlusThinIcon} from '../icon/svg/plus-thin-icon';
import {TextField} from '../textfield/textfield';

import styles from './number-input.module.css';

const MIN = 1;

type Props = {
    value: number;
    max?: number;
    onChange: (value: number) => void;
    hasError?: boolean;
};

export function NumberInput(props: Props) {
    const handleDecrement = () => {
        // TextField only performs validation onChange. Since this does not trigger the event,
        // we need to perform our own validation
        const newValue = props.value - 1;
        if (newValue >= MIN) {
            props.onChange(props.value - 1);
        }
    };

    const handleIncrement = () => {
        // TextField only performs validation onChange. Since this does not trigger the event,
        // we need to perform our own validation
        const newValue = props.value + 1;
        if (typeof props.max !== 'number' || newValue <= props.max) {
            props.onChange(props.value + 1);
        }
    };

    return (
        <div className={classnames('flex gap-8', styles.container)}>
            <button className='flex align-center justify-center' onClick={handleDecrement}>
                <MinusIcon size={11} />
            </button>
            <div className={styles['number-input']}>
                <TextField
                    id='numUsers'
                    value={typeof props.value === 'number' ? `${props.value}` : ''}
                    onChange={(number: string) => {
                        props.onChange(Number.parseInt(number));
                    }}
                    type='number'
                    min={`${MIN}`}
                    max={typeof props.max === 'number' ? `${props.max}` : undefined}
                    selectOnFocus={true}
                    hasError={props.hasError}
                    size='expand'
                    noPadding={true}
                />
            </div>
            <button className='flex align-center justify-center' onClick={handleIncrement}>
                <PlusThinIcon size={11} />
            </button>
        </div>
    );
}
